import PropTypes from 'prop-types';
import { useState } from 'react';
// next
import { useRouter } from 'next/router';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// config
import { HEADER, NAVBAR } from '../../config';
//
import NavHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
import { PATH_FLIERS, PATH_SCOUT, PATH_SALARY, PATH_AX } from '../../routes/paths';


// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'noHeader' && prop !== 'noPadding',
})(({ theme, noHeader, noPadding }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT + 8,
  paddingBottom: HEADER.MOBILE_HEIGHT + 8,
  ...noPadding && { paddingTop: HEADER.MOBILE_HEIGHT + 8, paddingBottom: 0 },
  ...noHeader && { paddingTop: 16, paddingBottom: 0 },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.MAIN_DESKTOP_HEIGHT,
    paddingBottom: HEADER.MAIN_DESKTOP_HEIGHT,
    ...noPadding && { paddingLeft: 0, paddingRight: 0, paddingTop: HEADER.MAIN_DESKTOP_HEIGHT, paddingBottom: 0 },
    ...noHeader && { paddingLeft: 0, paddingRight: 0, paddingTop: 32, paddingBottom: 0 },
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

const noHeaderWithQueryPaths = [
  PATH_FLIERS.root,
  PATH_SCOUT.root,
  PATH_SCOUT.recommend,
  PATH_SALARY.checkDetail,
  PATH_SALARY.completeDetail,
]

const noHeaderPaths = [
  PATH_SCOUT.recommend,
]

const noPaddingPaths = [
  PATH_FLIERS.root,
  PATH_FLIERS.proposal,
  PATH_FLIERS.profile,
  PATH_FLIERS.follower,
  PATH_SCOUT.root,
  PATH_SCOUT.manage,
  PATH_SCOUT.profile,
  PATH_SCOUT.recommend,
  PATH_AX.root,
]

export default function NavLayout({ children }) {
  const router = useRouter();

  // fliers 페이지에서 depth 를 더 들어갈때만 헤더를 노출하지 않는다. (=쿼리가 있을때만 헤더 미노출)
  const noHeader = (
    noHeaderWithQueryPaths.includes(router.pathname) && (Object.keys(router.query).length > 0)
    || noHeaderPaths.includes(router.pathname)
  );
  const noPadding = noPaddingPaths.includes(router.pathname) && (Object.keys(router.query).length === 0);

  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 },
      }}
    >
      {!noHeader && (
        <NavHeader onOpenSidebar={() => setOpen(true)} />
      )}

      <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <MainStyle noHeader={noHeader} noPadding={noPadding}>{children}</MainStyle>
    </Box>
  );
}
